import { LIST_CHI_PHI_CUOC_CONT } from "./actionTypes";

export const fetchDesBoatFee = (boatfee) => {
  return {
    type: LIST_CHI_PHI_CUOC_CONT,
    boatfee,
  };
};
